import React from 'react';
import { array, string } from 'prop-types';
import { intlShape, injectIntl} from 'react-intl';

import Card from '../Card/Card';

const propTypes = {
  files: array.isRequired,
  className: string,
  intl: intlShape.isRequired
};

const OfferFilesList = ({ files, className, intl: {formatMessage}, collapsing }) => (
  <Card.Collapsible
  collapsing={collapsing}
    className={className}
    title={formatMessage({id: "offer.files", defaultMessage: "Offer's files"})}
    label={formatMessage({id: "offer.files.show-all", defaultMessage: "Display all files"})}
    items={files}
  />
);

OfferFilesList.propTypes = propTypes;

export default injectIntl(OfferFilesList);
